// Copies data-copy (or, with data-copy="url", the page's URL without its
// query) to the clipboard, says so on the button for two seconds, and tells
// the LiveView which action was used (spec 2026-10-21 §6.4: "Index Cited").
// The button is phx-update="ignore", so its label is the hook's to change.
export const CopyText = {
  mounted() {
    this.label = this.el.textContent;
    this.el.addEventListener("click", () => this.copy());
  },

  text() {
    const value = this.el.dataset.copy;
    if (value !== "url") return value;
    return window.location.origin + window.location.pathname;
  },

  copy() {
    const done = () => {
      this.el.textContent = this.el.dataset.done || "Copied";
      setTimeout(() => (this.el.textContent = this.label), 2000);
      this.pushEvent("index_cited", { action: this.el.dataset.action });
    };

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(this.text()).then(done, () => {});
    } else {
      const area = document.createElement("textarea");
      area.value = this.text();
      document.body.appendChild(area);
      area.select();
      document.execCommand("copy");
      area.remove();
      done();
    }
  },
};
